import { TagPicker, ITag, Label } from "@fluentui/react";
import React, { useContext } from "react";
import styled from "styled-components";
import { ColumnOptionsContext } from "./ColumnOptions";
import { Column, TaxonomyFilter as TaxonomyFilterType } from "./types";

type Props = {
  column: Column;
};

export const TaxonomySelectFilter = ({ column }: Props) => {
  const filter = column.filter as TaxonomyFilterType;
  const { taxonomy, setFilter, t } = useContext(ColumnOptionsContext);

  const taxonomyList = taxonomy[filter.taxonomyKey] || [];
  const allOptions = taxonomyList
    .filter((tax) => {
      if (filter.exclude) {
        return !filter.exclude.includes(tax.code);
      }
      return true;
    })
    .map((tax) => ({
      key: tax.id.toString(),
      name: filter.customOptionLabel
        ? filter.customOptionLabel(tax)
        : t(tax.code),
      id: tax.id,
    }))
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));

  const selectedItems: ITag[] = filter.value
    .map((id) => allOptions.find((opt) => opt.id === id))
    .filter(Boolean)
    .map((opt) => ({
      key: opt!.key,
      name: opt!.name,
    }));

  const onResolveSuggestions = (filterText: string): ITag[] => {
    if (filter.onResolveSuggestions) {
      return filter.onResolveSuggestions(filterText, selectedItems) as ITag[];
    }
    return allOptions
      .filter(
        (opt) =>
          opt.name.toLowerCase().includes(filterText.toLowerCase()) &&
          !filter.value.includes(opt.id)
      )
      .map((opt) => ({ key: opt.key, name: opt.name }));
  };

  const onEmptyResolveSuggestions = (): ITag[] => {
    return allOptions
      .filter((opt) => !filter.value.includes(opt.id))
      .map((opt) => ({ key: opt.key, name: opt.name }));
  };

  return (
    <Container>
      <TagPicker
        selectedItems={selectedItems}
        onResolveSuggestions={onResolveSuggestions}
        onEmptyResolveSuggestions={onEmptyResolveSuggestions}
        onChange={(items) => {
          const value = (items || []).map((item) => Number(item.key));
          setFilter(column.key, {
            ...filter,
            value,
          });
        }}
        pickerSuggestionsProps={{
          suggestionsHeaderText: "",
          noResultsFoundText: "",
        }}
        itemLimit={filter.maxOptionsSelect}
      />
    </Container>
  );
};

const Container = styled.div`
  .ms-BasePicker-text {
    min-height: 32px;
  }
`;
